import { Container, Heading } from '@amelio/ui-library';

import { FeedbackResultsArrowIllustration } from '@/components/Illustrations/Illustration';
import { useAmelioTranslations } from '@/hooks';

export const EmptyPeriodResults = () => {
    const { t } = useAmelioTranslations();

    return (
        <>
            <div className={'relative'}>
                <FeedbackResultsArrowIllustration
                    className={'relative left-29 mt-50 -mb-70 sm:left-20 md:left-90 xl:left-120'}
                />
            </div>

            <Container
                px={'lg'}
                className={'mt-80 flex items-center justify-center'}
            >
                <Heading
                    level={3}
                    align={'center'}
                >
                    {t('errors.noEvaluationInPeriod')}
                </Heading>
            </Container>
        </>
    );
};
